import { http } from '@/http/axios.js'
export function getLoginCodeAPI(mobile) {
  return http({
    url: '/admin/auth/login/smsCode',
    method: 'post',
    data: {mobile}
  })
}
